export default __webpack_public_path__ + "static/media/fa-icon-32-pink.ec5d07ba.svg";